import React from "react";

export default function VehicleTitle({vehicle}) {

    return <>
      {vehicle.brand} {vehicle.model}
        {vehicle.configuration && `, ${vehicle.configuration}`}
        , {vehicle.year}
    </>
}